import {Box, Divider} from '@customink/pigment-react';
import React from 'react';

const TabbedProductDetailsDivider = () => {
  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: {lg: '63rem', xl: '80.25rem'},
        padding: '0 1rem',
        width: '100%'
      }}>
      <Divider />
    </Box>
  );
};

export default TabbedProductDetailsDivider;
